var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-section-page"},[_c('Pager',{staticClass:"section-list-pager",attrs:{"total":_vm.page.total,"page-size":_vm.page.pageSize,"current":_vm.page.pageNumber,"page-size-opts":[9, 18, 27, 36, 45, 54],"transfer":""},on:{"on-change":_vm.onPageChange,"on-page-size-change":_vm.onPageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }